import { Flex } from 'antd';
import TaskInfo from 'components/TaskInfo';
import { renderDate } from 'utils/helpers';
import { UserTableData } from '../table';

const UserDetailContent = ({
  data,
}: {
  data?: UserTableData;
  country: string;
}) => (
  <Flex wrap="wrap" style={{ rowGap: 10 }}>
    <TaskInfo header="Name" value={data?.name} />
    <TaskInfo header="Country" value={data?.country} />
    <TaskInfo header="Email" value={data?.email} />
    <TaskInfo header="Phone Number" value={data?.phoneNumber} />
    <TaskInfo header="Role" value={data?.roles?.join(', ')} />
    {data?.reportingToUserEmailList?.length ? (
      <TaskInfo
        header="Reporting To"
        value={data?.reportingToUserEmailList?.join(', ')}
      />
    ) : null}

    <TaskInfo header="Created At" value={renderDate(data?.createdAt)} />
  </Flex>
);

export default UserDetailContent;
